module.exports = __webpack_public_path__ + "img/green-carats.3e4d5e5d.svg";